import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IEquipmentType } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getEquipmentTypeList = (params: IDynamicTableParams): Promise<IEquipmentType[]> => {
  return instance(true, PPR_API_URL)
    .get('/dictionary/equipmentType/list', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getEquipmentTypeListAll = (): Promise<IEquipmentType[]> => {
  return instance(true, PPR_API_URL)
    .get('/dictionary/equipmentType/listAll')
    .then((response) => response.data);
};

export const getEquipmentTypeAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance(true, PPR_API_URL)
    .get('/dictionary/equipmentType/availableColumns')
    .then((response) => response.data);
};

export const getEquipmentTypeAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance(true, PPR_API_URL)
    .get('/dictionary/equipmentType/availableGroupColumns')
    .then((response) => response.data);
};

export const archiveEquipmentType = (equipmentTypeId: string, isDeleted: boolean) => {
  return instance(true, PPR_API_URL)
    .post('/dictionary/equipmentType/deleted/' + equipmentTypeId, { isDeleted })
    .then((response) => response.data);
};
